import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';
import { handleLocationMeta } from './../filters/actions';
import * as util from './../../util';

// manage test search box
export const setTestSearchValue = handleLocationMeta(
  createAction(types.SET_TEST_SEARCH_VALUE), util.searchValueTransformer);

// manage selected tests list
export const addToSelectedTests = createAction(types.ADD_TO_SELECTED_TESTS);
export const removeFromSelectedTests = createAction(types.REMOVE_FROM_SELECTED_TESTS);
export const clearSelectedTests = createAction(types.CLEAR_SELECTED_TESTS);

// manage selected tests group
export const selectTestGroup = createAction(types.SELECT_TEST_GROUP);
export const deselectTestGroup = createAction(types.DESELECT_TEST_GROUP);
export const clearTestsInGroup = createAction(types.CLEAR_TESTS_IN_GROUP);

export const getTestHistory = createApiAction(
  types.GET_TESTS,
  (payload) => api.getTestHistory(payload),
);

export const getTestsInGroup = createApiAction(
  types.GET_TESTS_IN_GROUP,
  (payload) => api.getTests(payload),
);
